/**
 * Claims API - Insurance claims (sinistres) management
 * @module api/claims
 */

import { apiRequest } from './core.js';

// =============================================================================
// CLAIM API
// =============================================================================

/**
 * Claim API - CRUD operations for insurance claims
 */
export const claimAPI = {
  getAll: () => apiRequest('/claim?_limit=5000'),
  getById: (id) => apiRequest(`/claim/${id}`),
  create: (claim) => apiRequest('/claim', {
    method: 'POST',
    body: JSON.stringify(claim),
  }),
  update: (id, claim) => apiRequest(`/claim/${id}`, {
    method: 'PUT',
    body: JSON.stringify(claim),
  }),
  delete: (id) => apiRequest(`/claim/${id}`, {
    method: 'DELETE',
  }),
  // Execute a workflow action on a claim (e.g., 'envoyer-declaration')
  workflowAction: (id, action, payload = {}) => apiRequest(`/claim/${id}/${action}`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }),
  // Get SLA alerts for open claims (overdue + warning)
  getAlerts: () => apiRequest('/claims/alertes'),

  // Affecter ou changer le garage — à n'importe quel moment du dossier.
  // Le garage est une donnée, pas une étape : cette route ne touche pas au statut.
  assignGarage: (id, payload) => apiRequest(`/claim/${id}/affecter-garage`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }),

  // Quelle étape peut-on défaire, et qu'est-ce que ça effacerait ? (lecture seule)
  getPreviousStep: (id) => apiRequest(`/claim/${id}/etape-precedente`),

  // Défaire la dernière étape. Motif obligatoire, journalisé.
  rollbackStep: (id, { reason, expectedStep }) => apiRequest(`/claim/${id}/revenir-etape`, {
    method: 'POST',
    body: JSON.stringify({ reason, expected_step: expectedStep || null }),
  }),
};

// =============================================================================
// CLAIM DOCUMENT API
// =============================================================================

/**
 * Claim Document API - Documents attached to claims
 */
export const claimDocumentAPI = {
  getAll: () => apiRequest('/claim_document?_limit=5000'),
  getById: (id) => apiRequest(`/claim_document/${id}`),
  getByClaim: (claimId) => apiRequest(`/claim_document?claim_id=${claimId}`),
  create: (document) => apiRequest('/claim_document', {
    method: 'POST',
    body: JSON.stringify(document),
  }),
  update: (id, document) => apiRequest(`/claim_document/${id}`, {
    method: 'PUT',
    body: JSON.stringify(document),
  }),
  delete: (id) => apiRequest(`/claim_document/${id}`, {
    method: 'DELETE',
  }),
};
